import * as THREE from 'three'
import { create } from 'zustand'

/** Angular slack before the contour pass is rebuilt (degrees). */
const REBUILD_EPSILON = Math.cos(THREE.MathUtils.degToRad(1.25))

interface ViewState {
  /**
   * Unit vector pointing from the camera into the scene, in world space.
   * Silhouette extraction depends on it, so it is deliberately quantised: free
   * orbiting rebuilds contours a few dozen times, not once per frame.
   */
  direction: THREE.Vector3
  setDirection: (next: THREE.Vector3) => void
}

export const useViewStore = create<ViewState>((set, get) => ({
  direction: new THREE.Vector3(-1, -1, -1).normalize(),
  setDirection: (next) => {
    const current = get().direction
    if (current.dot(next) > REBUILD_EPSILON) return
    set({ direction: next.clone().normalize() })
  },
}))
